import { Oval } from 'react-loader-spinner';
import './Loader.css';

function Loader() {
  return (
    <div className='center'>
      <div>
        <Oval
          height={80}
          width={80}
          color='#c0dbd9'
          wrapperStyle={{}}
          wrapperClass=''
          visible={true}
          ariaLabel='oval-loading'
          secondaryColor='#f2f6f6'
          strokeWidth={5}
          strokeWidthSecondary={5}
        />
      </div>
    </div>
  );
}

export default Loader;
